import React from 'react'

function Column66Icon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      width="46"
      height="35"
      viewBox="0 0 46 35"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0.5,34.5 L20.1875,34.5 L20.1875,0.75 L0.5,0.75 L0.5,34.5 Z M25.8125,0.75 L25.8125,34.5 L45.5,34.5 L45.5,0.75 L25.8125,0.75 Z" />
    </svg>
  )
}

export default Column66Icon
